import { Component, OnInit, AfterViewInit, ViewChild, NgModule } from '@angular/core';
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { Router } from '@angular/router';
import { Http } from '@angular/http';
import { UserService } from '../../user/user.service';
import { SharedService } from '../../home/shared.service';
import { AlertService } from '../../util/alert/alert.service';
import { CoreCompetencyService } from './corecompetency.service';
import { ModalComponent } from 'ng2-bs3-modal/ng2-bs3-modal';
import { TableComponent } from '../../util/table/table.component';
import { BrowserModule } from '@angular/platform-browser';
import { CoreCompetency } from './corecompetency.model';
import { CustomModalService } from '../../util/custommodal/custommodal.service';

@Component({
	selector: 'app-corecompetency',
	templateUrl: './allcorecompetency.component.html'
})

export class AllCoreCompetencyComponent extends TableComponent {
	selectedCompId: string;
	selectedCompStatus: number;
	newStatus: string;
	selectedCompShowHide: number;

	public selectedUserRole = [];
	public stortedSelectedUserRole = localStorage.getItem('selectedUserRole');
	private isDeleteCC: boolean;
	private isModifyCC: boolean;
	isAddCC: boolean;
	private isQueryCC: boolean;
	showHideForm: FormGroup;
	public tagList = [];
	checked: boolean = false;
	
	public columns: Array<any> = [
		{ title: 'Core Competency', name: 'coreCompetency', filtering: { filterString: '', placeholder: '' } },
		{ title: '', name: 'statusbutton', className: 'accepter-col-action' },
		{ title: '', name: 'editbutton', className: 'accepter-col-action' },
		{ title: '', name: 'deletebutton', className: 'accepter-col-action' },
		{ title: '', name: 'showhidebutton', className: 'accepter-col-action' }
	];

	config: any = {
		paging: true,
		sorting: { columns: this.columns },
		filtering: { filterString: "" },
		className: ["table-striped", "table-bordered"]
	};

	constructor(private customModalService: CustomModalService, private router: Router, private userService: UserService,
		private sharedService: SharedService, private alertServices: AlertService,
		private coreCompetencyService: CoreCompetencyService) {
		super();
		if (!userService.isValidLoggedIn()) {
			userService.redirectToLoginScreen();
		}

		if (this.selectedUserRole) {
			this.selectedUserRole = JSON.parse(this.stortedSelectedUserRole);
		}
		//get user capabilities
		this.isAddCC = this.userService.isCapabilityAssigned('AddCompLib', this.selectedUserRole[0][1]);
		this.isModifyCC = this.userService.isCapabilityAssigned('ModifyCompLib', this.selectedUserRole[0][1]);
		this.isDeleteCC = this.userService.isCapabilityAssigned('DeleteCompLib', this.selectedUserRole[0][1]);
		this.isQueryCC = this.userService.isCapabilityAssigned('QueryCompLib', this.selectedUserRole[0][1]);
	}

	ngOnInit() {
		//Called after the constructor, initializing input properties, and the first call to ngOnChanges.
		//Add 'implements OnInit' to the class.
		//load data after check the permissions
		if (this.isQueryCC) {
			this.loadAllShowCoreCompetencies();
		} else {
			//do nothing
		}

		this.showHideForm = new FormGroup({
			showHide: new FormControl(null)
		});
	}

	selectedComponentItem(itemName: string) {
		this.sharedService.change(itemName);
	}

	//on cell click event
	public onCellClick(data: any): any {
		//console.log('[onCellClick] (selectedRow) : ' + JSON.stringify(data.row.id));
		this.selectedCompId = data.row.id;
		this.selectedCompStatus = data.row.status;
		this.selectedCompShowHide = data.row.showHide;
		this.newStatus = this.selectedCompStatus == 1 ? "disable" : "enable";
		switch (data.column) {
			case 'editbutton':
				if (this.isModifyCC) {
					this.editButtonClickEvent(data.row.id, data.row.coreCompetency);
				} else {
					//do nothing
				}
				break;
			case 'deletebutton':
				if (this.isDeleteCC) {
					this.deleteButtonClickEvent(this.selectedCompId);
				} else {
					//do nothing
				}
				break;
			case 'statusbutton':
				if (this.isModifyCC) {
					if (this.selectedCompShowHide == 0) {
						//do nothing
					} else {
						this.statusButtonClickEvent(this.selectedCompId, this.selectedCompStatus);
					}
				} else {
					//do nothing
				}
				break;
			case "showhidebutton":
				//check delete capability
				if (this.isModifyCC) {
					if (data.row.status == 0 || data.row.showHide == 0) {
						this.showHideButtonClickEvent(this.selectedCompId, this.selectedCompShowHide);
					} else {
						//do nothing
					}
				} else {
					//modify capability is not assigned
				}
				break;
			default:
				break;
		}
	}

	private deleteButtonClickEvent(id: string) {
		let itemType = "Core Competency";
		this.customModalService.invoke(
			itemType,
			id,
			this,
			"delete", null
		);
	}

	private delete() {
		this.coreCompetencyService.deleteCoreCompetency(this.selectedCompId)
			.subscribe(
			data => {
				this.alertServices.clear();
				this.alertServices.success("Successfully removed the core competency.");
				this.loadData();
			},
			error => {
				this.alertServices.clear();
				let err = error.json();
				this.alertServices.handleError(err);
			}
			);
	}

	private editButtonClickEvent(compId: string, coreCompetency: string) {
		this.coreCompetencyService.getAssignedCCTagList(compId)
			.subscribe(
			data => {
				//console.log('[editButtonClickEvent] ' + JSON.stringify(data).toString());
				this.tagList = []
				data.assignTagList.forEach(element => {
					let item = { value: element.Description, id: element.CCTagId }
					this.tagList.push(item);
				});

				let tempCC: CoreCompetency = new CoreCompetency(compId, coreCompetency)
				tempCC.tagList = this.tagList
				this.coreCompetencyService.setSelectedCCModel(tempCC)
				this.sharedService.change('EditCoreCompetency');
			},
			error => {
				this.alertServices.clear();
				let err = error.json();
				this.alertServices.handleError(err);
			}
			);
	}

	private statusButtonClickEvent(id: string, status: number) {
		let itemType = "Core Competency";
		this.customModalService.invoke(
			itemType,
			id,
			this,
			"statusChange",
			status
		);
	}

	private changeStatus(compId: string, status: number) {
		this.coreCompetencyService.changeCoreCompetencyStatus(compId, status == 1 ? 0 : 1)
			.subscribe(
			data => {
				this.alertServices.clear();
				this.alertServices.success(data.message);
				this.loadData();
			},
			error => {
				this.alertServices.clear();
				let err = error.json();
				this.alertServices.handleError(err);
			}
			);
	}

	public extendData() {
		//for every row
		for (let i = 0; i < this.data.length; i++) {
			//check user modify capability
			if (this.isModifyCC) {
				this.data[i].editbutton = '<a class="action-btn edit" style="cursor: pointer"><i class="fa fa-pencil-square-o fa-lg" aria-hidden="true"></i></a>';
				if (this.data[i].status == 1) {
					this.data[i].statusbutton = '<a class="btn btn-sm " style="cursor: pointer"><i class="fa fa-check-circle-o fa-lg" aria-hidden="true"></i></a>';
				} else {
					if (this.data[i].showHide == 0) {
						this.data[i].statusbutton = '<a class="btn btn-sm disabled" ><i class="fa fa-times-circle-o fa-lg" aria-hidden="true" style="color:grey"></i></a>';
					}
					else {
						this.data[i].statusbutton = '<a class="btn btn-sm " style="cursor: pointer"><i class="fa fa-times-circle-o fa-lg" aria-hidden="true"></i></a>';
					}
				}
			} else {
				this.data[i].editbutton = '<a class="btn btn-sm disabled edit"><i class="fa fa-pencil-square-o fa-lg" aria-hidden="true"></i></a>';
				if (this.data[i].status == 1) {
					this.data[i].statusbutton = '<a class="btn btn-sm disabled"><i class="fa fa-check-circle-o fa-lg" aria-hidden="true"></i></a>';
				} else {
					this.data[i].statusbutton = '<a class="btn btn-sm disabled"><i class="fa fa-times-circle-o fa-lg" aria-hidden="true"></i></a>';
				}
			}
			if (this.isDeleteCC) {
				this.data[i].deletebutton = '<a class="action-btn delete" style="cursor: pointer"><i class="fa fa-trash-o fa-lg" aria-hidden="true"></i></a>';
			} else {
				this.data[i].deletebutton = '<a class="btn btn-sm disabled delete"><i class="fa fa-trash-o fa-lg" aria-hidden="true"></i></a>';
			}

			if (this.data[i].showHide == 1) {
				if (this.data[i].status == 0) {
					if (this.isModifyCC) {
						this.data[i].showhidebutton =
							'<a class="btn btn-sm edit"><i class="fa fa-eye fa-lg" aria-hidden="true"></i></a>';
					} else {
						this.data[i].showhidebutton =
							'<a class="btn btn-sm  disabled edit"><i class="fa fa-eye fa-lg" aria-hidden="true" ></i></a>';
					}
				} else {
					this.data[i].showhidebutton =
						'<a class="btn btn-sm  disabled edit"><i class="fa fa-eye fa-lg" aria-hidden="true" ></i></a>';
				}

			} else {
				if (this.isModifyCC) {
					this.data[i].showhidebutton =
						'<a class="btn btn-sm edit"><i class="fa fa-eye-slash fa-lg" aria-hidden="true" style="color:red"></i></a>';
				} else {
					this.data[i].showhidebutton =
						'<a class="btn btn-sm  disabled edit"><i class="fa fa-eye-slash fa-lg" aria-hidden="true" style="color:red"></i></a>';
				}
			}
		}
	}

	private loadAllCoreCompetencies() {
		this.coreCompetencyService.getAllCoreCompetencies()
			.subscribe(
			data => {
				this.data = [];
				//console.log('[loadAllCoreCompetency] ' + JSON.stringify(data).toString());
				for (let i = 0; i < data.length; i++) {
					this.data.push({
						'id': data[i].Id,
						'coreCompetency': data[i].Description,
						'status': data[i].Status,
						'showHide': data[i].ShowHide,
						'statusbutton': '', 'editbutton': '', 'deletebutton': '', 'showhidebutton': ''
					});
				}
				this.pageCount = Math.ceil(this.data.length / this.itemsPerPage);
				this.onChangeTable(this.config);
				this.extendData();
			},
			error => {
				this.alertServices.clear();
				let err = error.json();
				this.alertServices.handleError(err);
			}
			);
	}

	private loadAllShowCoreCompetencies() {
		this.coreCompetencyService.getAllShowCoreCompetencies()
			.subscribe(
			data => {
				//console.log('[loadAllCoreCompetency] ' + JSON.stringify(data).toString());
				this.data = [];
				for (let i = 0; i < data.length; i++) {
					this.data.push({
						'id': data[i].Id,
						'coreCompetency': data[i].Description,
						'status': data[i].Status,
						'showHide': data[i].ShowHide,
						'statusbutton': '', 'editbutton': '', 'deletebutton': '', 'showhidebutton': ''
					});
				}
				this.pageCount = Math.ceil(this.data.length / this.itemsPerPage);
				this.onChangeTable(this.config);
				this.extendData();
			},
			error => {
				this.alertServices.clear();
				let err = error.json();
				this.alertServices.handleError(err);
			}
			);
	}

	showHide(event) {		
		this.checked = !this.checked;
		if (event.target.checked) {
			if (this.isQueryCC) {
				this.loadAllCoreCompetencies();
			} else {
				//noo need to display data
			}
		} else {
			this.loadAllShowCoreCompetencies();
		}
	}

	public showHideButtonClickEvent(id: string, showHide: number) {
		let itemType = "Core Competency";
		let status = showHide;
		this.customModalService.invoke(
			itemType,
			id,
			this,
			"showHide",
			status
		);
	}

	loadData() {
		if (this.checked) {
			this.loadAllCoreCompetencies();
		}
		else {
			this.loadAllShowCoreCompetencies();
		}
	}

	public showHideEvent(checklistId: string, showHide: number) {
		this.coreCompetencyService.changeCCShowHide(checklistId, showHide == 1 ? 0 : 1)
			.subscribe(
			data => {
				this.alertServices.clear();
				this.alertServices.success(data.message);
				this.loadData();
			},
			error => {
				this.alertServices.clear();
				let err = error.json();
				this.alertServices.handleError(err);
			}
			)
	}

}
